<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">

        <v-row dense class="mt-2">
          <v-col align="center" class="ma-0 pa-0 text-center blue darken-4">
            <div class="topHeader">
              <label v-if="typeRecord != null" class="white--text font-weight-bold">{{ groupId }}<br />{{typeRecord.qual}}</label>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-0 ma-0">
            <v-list>
              <v-list-item-group
                active-class="blue--text"
              >
                <template v-for="(item, index) in cps">
                  <v-list-item :key="index">
                    <!-- eslint-disable-next-line -->
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-content>
                        <v-list-item-title class="subtitle-1 font-weight-bold blue--text text--darken-4" v-text="item.checkpilot"></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-list-item-action-text >
                          <v-btn v-if="item.homephone != 'N/A'" class="mr-3" fab dark x-small  color="blue darken-4" :href="`tel:+1${item.homephone}`">
                            <v-icon small dark>mdi-phone</v-icon>
                          </v-btn>
                          <v-btn v-if="item.cellphone != 'N/A'" class="mr-3" fab dark x-small color="green darken-4" :href="`tel:+1${item.cellphone}`">
                            <v-icon small dark>mdi-cellphone</v-icon>
                          </v-btn>
                          <v-btn depressed outlined medium text icon color="blue darken-4" :to="`/checkpilotlist/${groupId}/${typeId}/${item.capid}`">
                              <v-icon >
                                mdi-chevron-right
                              </v-icon>
                          </v-btn>
                        </v-list-item-action-text>

                      </v-list-item-action>
                    </template>
                  </v-list-item>

                  <v-divider
                  :key="item.capid + index"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Data...
          <v-progress-linear
            indeterminate
            rounded
            color="white"
            class="mb-0"
            height="20px"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->   
  </div>
</template>

<script>

export default {
  name: 'CheckPilotList',
  props: ['groupId','typeId'],
  components: {
  },
  data () {
    return {
      isLoading: false,
      alwaysAvailableModal: false,
      cps: [],
      typeRecord: {}
    }
  },
  mounted() {
    this.getData(this.groupId,this.typeId);
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
  },
  methods: {
    getData(groupId,typeId) {

      this.isLoading = true;
      var obj={}


        obj = {
            wing: this.selWing,
            qualid: typeId,
            unit: groupId
        };

        this.$https.post(this.$vars.BaseUrl + this.$vars.GetCheckPilotListRoute, obj, this.$vars.config)
        .then(response => {
          //console.log(response);
          this.httpResponse = response;
          var resultData = response.data;
          this.cps = resultData;
          this.setCheckPilotList(response.data);
          var tempTypes = this.lookupCheckPilotTypes;
          const result = tempTypes.filter(item => (item.qualid == this.typeId));
          this.typeRecord = result[0];
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });
    }
  }
}
</script>

<style scoped>
  .topHeader {
    height:45px;
  }

</style>
